import React from 'react';
import '../CSS/Company.css';

const Company: React.FC = () => {
  return (
    <div className="company-page">
      <div className="company_banner">
        <div className="company-banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Company Overview</h1>
        </div>
      </div>
      
      <div className="company-description">
        <div className="company-description-content">
          <p className="company-description-text">
            Zemantics LLC is an innovative AI and software engineering company based in Princeton, New Jersey. With a robust presence in generative AI, data engineering, software development for AI products, and AI/ML integration, Zemantics delivers end-to-end solutions—from ideation through deployment and beyond.
          </p>
        </div>
      </div>
      
      <div className="company_mission">
        <div className="company-mission-content">
          <h2 className="mission-title">Mission</h2>
          <p className="mission-description">
            Zemantics exists to <strong>demystify and democratize AI</strong>, serving as your trusted guide from initial concept to full-scale deployment. By integrating cutting-edge AI into your systems, we empower businesses to harness the full potential of data and drive meaningful impact. Whether in healthcare, enterprise software, or digital transformation, Zemantics helps you embrace AI with clarity and confidence.
          </p>
        </div>
      </div>
      
      <div className="team_and_leader">
        <div className="team-leadership-content">
          <div className="team-image-section">
            <img src="/Assets/Company/team-leadership-banner-image.png" alt="Team & Leadership" className="team-image" />
          </div>
          <div className="team-text-section">
            <h2 className="team-title">Team & Leadership</h2>
            <p className="team-description">
              Zemantics boasts a seasoned leadership team with deep expertise across domains. With combined experience spanning over 250 years and a track record of delivering innovative solutions globally, this leadership team brings deep knowledge across strategy, AI, and technology.
            </p>
          </div>
        </div>
      </div>
      
      <div className="values_and_diff">
        <div className="values-diff-content">
          <h2 className="values-diff-title">Values & Differentiators</h2>
          <div className="values-diff-cards">
            <div className="values-diff-card">
              <div className="values-card-icon">
                <img src="/Assets/Company/collaborative-innovation-icon.svg" alt="Collaborative Innovation" />
              </div>
              <h3 className="values-card-title">Collaborative Innovation</h3>
              <p className="values-card-description">Zemantics co-creates with clients, fostering environments where curiosity and strategic thinking flourish.</p>
            </div>

            <div className="values-diff-card">
              <div className="values-card-icon">
                <img src="/Assets/Company/cross‑functional-expertise-icon.svg" alt="Cross-Functional Expertise" />
              </div>
              <h3 className="values-card-title">Cross-Functional Expertise</h3>
              <p className="values-card-description">Offering deep capabilities across data science, AI, digital strategy, healthcare, cybersecurity, and more—enabling holistic solutions.</p>
            </div>

            <div className="values-diff-card">
              <div className="values-card-icon">
                <img src="/Assets/Company/proven-technical-process-icon.svg" alt="Proven Technical Process" />
              </div>
              <h3 className="values-card-title">Proven Technical Process</h3>
              <p className="values-card-description">Built over 175+ software products over 15+ years, cementing Zemantics' proficiency in custom software development for AI-centered domains.</p>
            </div>

            <div className="values-diff-card">
              <div className="values-card-icon">
                <img src="/Assets/Company/domain-driven-approach-icon.svg" alt="Domain-Driven Approach" />
              </div>
              <h3 className="values-card-title">Domain-Driven Approach</h3>
              <p className="values-card-description">Specialized services in generative AI, ML, and data engineering, adapting tools and techniques to each client's needs—from model architecture to deployment frameworks.</p>
            </div>

            <div className="values-diff-card">
              <div className="values-card-icon">
                <img src="/Assets/Company/agile-icon.svg" alt="Agile & Scalable Delivery" />
              </div>
              <h3 className="values-card-title">Agile & Scalable Delivery</h3>
              <p className="values-card-description">Utilizes agile methodologies, UI/UX adaptability, robust testing/QA, and modern tech stacks—spanning cloud platforms, containers, and orchestration tools—tailored to fast-evolving business needs.</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="key_partnership_statistics">
        <div className="partnership-content">
          <h2 className="partnership-title">Key Partnerships & Achievements</h2>
          
          <div className="partnership-descriptions">
            <p className="partnership-description">
              <strong>Growth Through Ventures:</strong> Operates through Zemantics Ventures, partnering with enterprises across sectors such as AI, data science, executive search, digital strategy, healthcare, cybersecurity, hospitality, and more.
            </p>
            <p className="partnership-description">
              <strong>Impressive Track Record:</strong> Over 1,200 projects completed, powered by 1,800 design resources, and a 100% client satisfaction rate—highlighting reliability and deep client commitment.
            </p>
          </div>
          
          <div className="partnership-stats">
            <div className="stat-item">
              <div className="stat-number">1,200+</div>
              <div className="stat-label">PROJECTS COMPLETED</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">1,800+</div>
              <div className="stat-label">DESIGN RESOURCES</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100%</div>
              <div className="stat-label">CLIENT SATISFACTION RATE</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
